import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '@/views/AITools/store/index'
// components
import AIToolTextarea from '../components/AI-Tool-Textarea/AI-Tool-Textarea.vue'
import AIToolResult from '../components/AI-Tool-Result/AI-Tool-Result.vue'
import AIToolSubmit from '../components/AI-Tool-Submit/AI-Tool-Submit.vue'
// enum
import { AIToolNameEnum, AIToolSourceEnum, AIGenerateStatusEnum } from '@/constants/AI-tool'
// utils
import { debounce } from 'lodash-es'
import { toast } from '@/utils/util'
import { checkTextContent } from '@/utils/utils';

@Component({
  components: {
    AIToolTextarea,
    AIToolResult,
    AIToolSubmit
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class AIGoldStart extends Vue {

  /****************************** 常量 ******************************/

  AIToolName = AIToolNameEnum.GOLD_START

  AIToolSource = AIToolSourceEnum.GOLD_START

  /****************************** 生命周期 ******************************/

  mounted() {
    const token = this.$route.query.ww_token
    if (!token) {
      localStorage.removeItem('ww_token')
    }

    const id = this.$route.query.id
    if (id) {
      // 获取重新生成的内容
      this.getGeneratedInputContent(Number(id))
    }
    // 登录完成跳转回来回填内容
    this.getLocalStorageInputContent()
  }

  beforeDestroy() {
    clearTimeout(this.timeout)
  }

  /****************************** 回填表单内容 ******************************/

  /** 跳转到登录页 */
  toLoginPage() {
    localStorage.setItem('AI_gold_start_input_content', JSON.stringify({
      text: this.text
    }))
    this.$redirectTo({
      url: `/pages/login/login?from=${ 'AITool' }&redirect=${ '/package-tools/pages/ai-gold-start/ai-gold-start' }&timestamp=${ new Date().getTime() }`
    })
  }

  /** 获取已经生成的 input 内容 */
  getGeneratedInputContent(recordId: number) {
    this.$http('getGeneratedResultApi', { recordIds: [ recordId ] })
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          const result = data[0] || {}
          // 输入内容
          let handleText = result.input?.citationVO?.content || ''
          if (handleText.length > this.maxLength) {
            handleText = handleText.slice(0, this.maxLength)
          }
          this.text = handleText
        } else {
          toast(message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  /** 登录返回时获取 localStorage 存储的表单输入内容 */
  getLocalStorageInputContent() {
    const inputContent = localStorage.getItem('AI_gold_start_input_content')
    if (inputContent) {
      const { text } = JSON.parse(inputContent)
      this.text = text
      // 清除存储的数据
      localStorage.removeItem('AI_gold_start_input_content')
    }
  }

  /****************************** 文本输入 ******************************/

  text = ''

  // 输入文本的最长长度
  maxLength = 5000

  /****************************** 生成黄金开场 ******************************/

  // 生成状态 ( Pending: 等待生成状态; Generating: 正在生成状态; Finish: 生成完成; )
  generatedStatus = AIGenerateStatusEnum.PENDING
  // 生成结果
  generatedResult = ''

  /** 提交生成 */
  async handleSubmit() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) {
      this.toLoginPage()
      return
    }
    if (!this.text) {
      toast('请输入内容')
      return
    }
    // 检测文案风险
    const checkRes = await checkTextContent(this, this.text);
    if (checkRes) return;

    // 状态设为正在生成中
    this.generatedStatus = AIGenerateStatusEnum.GENERATING
    // 防抖
    this.debounceGenerate()    
  }

  debounceGenerate = debounce(function() {
    const requestData = {
      type: 'CITATION',
      citationVO: {
        content: this.text
      },
      autoUpdateArticle: false
    }
    this.$http('generateGoldStartApi', requestData)
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          this.getGeneratedResult(data.id)
        } else {
          this.generatedStatus = AIGenerateStatusEnum.PENDING
          toast(message)
        }
      })
      .catch((error) => {
        this.generatedStatus = AIGenerateStatusEnum.PENDING
        console.error(error)
      })
  }, 500)

  /** 重新生成 */
  handleRetry() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) {
      this.toLoginPage()
      return
    }
    if (!this.text) {
      toast('请输入内容')
      return
    }
    // 设置生成状态为初始状态
    this.generatedStatus = AIGenerateStatusEnum.PENDING
    // 重新发起生成请求
    this.handleSubmit()
  }

  /****************************** 轮询查询生成结果 ******************************/

  timeout = null

  /** 查询生成结果 */
  getGeneratedResult(recordId: number) {
    this.$http('getGeneratedResultApi', { recordIds: [ recordId ] })
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          const result = data[0] || {}
          switch(result.status) {
            // 生成中
            case 1:
              this.timeout = setTimeout(() => {
                this.getGeneratedResult(recordId)
              }, 3000)
              break;
            // 生成成功
            case 2:
              // 生成内容
              this.generatedResult = result?.output?.content || ''
              // 设为生成完成状态
              this.generatedStatus = AIGenerateStatusEnum.FINISH
              break;
            // 生成失败
            case 3:
              // 设为生成初始状态
              this.generatedStatus = AIGenerateStatusEnum.PENDING
              toast('查询结果失败')
              break;
          }
        } else {
          toast(message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

}
